module.exports = __webpack_public_path__ + "static/3-0981081aafef4aff36abfe0a63d9ebc8.jpg";